/**
 * Fills the header placeholders of the e-mail template for the preview, the way the backend does when it sends
 * (EmailSilo/Services/EmailDocument.cs): the uploaded image or the default; the alt text, empty when none is set
 * (a decorative header), attribute-encoded with '@' encoded so it cannot expand another placeholder. Call it before
 * @Subject and @Body are filled, again like the backend. Replacer functions, so '$' in a value is never a
 * replacement pattern.
 */
const encodeAttribute = (value: string) =>
    value.replaceAll('&', '&amp;').replaceAll('"', '&quot;').replaceAll("'", '&#39;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');

export const fillHeaderPlaceholders = (template: string, header: { url?: string | null; defaultUrl: string; altText?: string }) => {
    const url = header.url || header.defaultUrl;
    const alt = header.altText?.trim() ?? '';

    return template
        .replace(/@HeaderImageUrl/gi, () => encodeAttribute(url))
        .replace(/@HeaderImageAlt/gi, () => encodeAttribute(alt).replaceAll('@', '&#64;'));
};

export const hasHeaderImagePlaceholder = (template: string) => /@HeaderImageUrl/i.test(template);
